define('components/photoset/layouts/fitRow/row', [
    'components/photoset/layouts/base/row',
    'components/photoset/complexNumber'
], function (Base, ComplexNumber) {
    function Model(jsonModel) {
        Base.call(this, jsonModel);

        this.items = ko.observableArray(jsonModel.items);
        this.offset = jsonModel.offset;
        this.expand = jsonModel.expand;

        this.minRelWidth = ko.observable(jsonModel.minRelWidth).unwrap().default(0);
        this.realRelWidth = this.items.reduce(function (result, item) { return result + item.relWidth() }, () => 0);
        this.relWidth = ko.pureComputed(this._getFinalRelWidth, this);

        this.height = ko.pureComputed(this._getHeight, this);
    }

    Model.prototype = Object.create(Base.prototype);
    Model.prototype.constructor = Model;

    Model.prototype.append = function (item) {
        this.items.push(item);
    };

    Model.prototype._getFinalRelWidth = function () {
        if (this.expand())
            return this.realRelWidth();

        return this.realRelWidth() < this.minRelWidth() ? this.minRelWidth() : this.realRelWidth();
    };

    Model.prototype._getHeight = function () {
        var width = this.relWidth();

        if (width > 0) {
            var height = 1 / width;

            return new ComplexNumber(100 * height, -this.offset() * (this.items().length - 1) * height);
        }

        return new ComplexNumber();
    };

    return Model;
});